export default __webpack_public_path__ + "static/Love-01eb7188ce96d7d3db070a4cc6585532.png";